import { ref, watch, onMounted } from 'vue'

const isDark = ref(false)

export function useDarkMode() {
  const toggleDarkMode = () => {
    isDark.value = !isDark.value
    updateTheme()
  }

  const updateTheme = () => {
    if (isDark.value) {
      document.documentElement.classList.add('dark-mode')
      document.body.classList.add('dark-mode')
      localStorage.setItem('theme', 'dark')
      console.log('✅ Dark mode activated, classes added to html and body')
    } else {
      document.documentElement.classList.remove('dark-mode')
      document.body.classList.remove('dark-mode')
      localStorage.setItem('theme', 'light')
      console.log('✅ Light mode activated, classes removed from html and body')
    }
  }

  const initTheme = () => {
    // Проверяем сохраненную тему или системные настройки
    const savedTheme = localStorage.getItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

    isDark.value = savedTheme === 'dark' || (!savedTheme && prefersDark)
    updateTheme()
  }

  return {
    isDark,
    toggleDarkMode,
    initTheme
  }
}

